import { render, staticRenderFns } from "./LastPositionsTable.vue?vue&type=template&id=3484b338&"
import script from "./LastPositionsTable.vue?vue&type=script&lang=js&"
export * from "./LastPositionsTable.vue?vue&type=script&lang=js&"
import style0 from "./LastPositionsTable.vue?vue&type=style&index=0&id=3484b338&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports